<template>
	<div>
		<div class="mb-4">
			<h1 class="h3 mb-0">Catégoriser la note de frais</h1>
		</div>
		<div class="cards-grid">
			<button
				type="button"
				class="dashboard-card"
				:class="{'active bg-light border-primary': category === 'fuel'}"
				@click.prevent="updateCategory('fuel')"
			>
				<div class="card-icon fuel d-flex align-items-center justify-content-center rounded-3 me-3"
					 style="width: 48px; height: 48px;">
					<i class="fas fa-gas-pump fs-4"></i>
				</div>
				<div class="text-start">
					<h3 class="h5 mb-1">Carburant</h3>
					<p class="mb-0 text-muted small">Essence, diesel, électrique</p>
				</div>
			</button>
			<button
				type="button"
				class="dashboard-card"
				:class="{'active bg-light border-success': category === 'restaurant'}"
				@click.prevent="updateCategory('restaurant')"
			>
				<div class="card-icon restaurant d-flex align-items-center justify-content-center rounded-3 me-3"
					 style="width: 48px; height: 48px;">
					<i class="fas fa-utensils fs-4"></i>
				</div>
				<div class="text-start">
					<h3 class="h5 mb-1">Restaurant Interne</h3>
					<p class="mb-0 text-muted small">Repas d'équipe, déjeuners</p>
				</div>
			</button>
			<button
				type="button"
				class="dashboard-card"
				:class="{'active bg-light border-warning': category === 'restaurantclient'}"
				@click.prevent="updateCategory('restaurantclient')"
			>
				<div class="card-icon restaurant-client d-flex align-items-center justify-content-center rounded-3 me-3"
					 style="width: 48px; height: 48px;">
					<i class="fas fa-user-tie fs-4"></i>
				</div>
				<div class="text-start">
					<h3 class="h5 mb-1">Restaurant Client</h3>
					<p class="mb-0 text-muted small">Repas d'affaires, réceptions</p>
				</div>
			</button>
			<button
				type="button"
				class="dashboard-card"
				:class="{'active bg-light border-info': category === 'transportation'}"
				@click.prevent="updateCategory('transportation')"
			>
				<div class="card-icon transport d-flex align-items-center justify-content-center rounded-3 me-3"
					 style="width: 48px; height: 48px;">
					<i class="fas fa-subway fs-4"></i>
				</div>
				<div class="text-start">
					<h3 class="h5 mb-1">Transport</h3>
					<p class="mb-0 text-muted small">Train, métro, taxi</p>
				</div>
			</button>
			<button
				type="button"
				class="dashboard-card"
				:class="{'active bg-light border-secondary': category === 'misc'}"
				@click.prevent="updateCategory('misc')"
			>
				<div class="card-icon misc d-flex align-items-center justify-content-center rounded-3 me-3"
					 style="width: 48px; height: 48px;">
					<i class="fas fa-receipt fs-4"></i>
				</div>
				<div class="text-start">
					<h3 class="h5 mb-1">Divers</h3>
					<p class="mb-0 text-muted small">Autres dépenses</p>
				</div>
			</button>
		</div>
		<n-button @click="back()" class="me-2">
			<template #icon>
				<i class="fas fa-arrow-left me-2"></i>
			</template>
			Retour
		</n-button>
	</div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import {NButton} from "naive-ui";

export default {
	name: 'Categories',
	components: {NButton},
	data() {
		return {
			category: null
		}
	},
	mounted() {
		this.category = this.getCategory;
	},
	computed: {
		...mapGetters(['getCategory', 'getId']),
	},
	methods: {
		back() {
			let route = this.getId ? '/index' : '/';
			this.$router.push(route);
		},
		updateCategory(category) {
			this.$store.dispatch('setCategory', category);

			if (this.$route.params.id) {
				this.$emit('changePath', 'dataValidation');
			} else {
				this.$emit('changePath', 'capture');
			}
		}
	}
}
</script>


<style scoped>
/* Seuls les styles qui ne peuvent pas être gérés par Bootstrap */

</style>